module.exports = __webpack_public_path__ + "assets/img/help_image01-4@2x.7680cda9.png";